import { baseApi } from '@klp/core/api';
import { generateApiRoute } from '@klp/core/api/helpers';
import { fromUTC } from '@klp/helpers';
import { User } from '@klp/user/classes/User';

import { brukerApiName, userApiName } from '../api';
import type { UserResponse } from '../interfaces';

interface BrukerTokenAccess {
    isAdmin: boolean;
}

const userApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
        getCurrentUser: build.query<User, BrukerTokenAccess>({
            query: () => {
                return {
                    url: generateApiRoute([
                        brukerApiName,
                        userApiName,
                        'bytoken',
                    ]),
                    method: 'GET',
                };
            },
            transformResponse: (response: any): User => {
                const userResponse: UserResponse = {
                    ...response,
                    velkomstMeldingSendt: response.velkomstMeldingSendt
                        ? new Date(fromUTC(response.velkomstMeldingSendt))
                        : undefined,
                };
                return new User(
                    Object.assign({}, userResponse, {
                        id: userResponse.brukerId,
                        email: userResponse.epost,
                        firstName: userResponse.fornavn,
                        lastName: userResponse.etternavn,
                        isAdmin: userResponse.internalUser,
                        customers: userResponse.kundenummerList,
                        welcomeMessageSent: userResponse.velkomstMeldingSendt,
                        isAdminUserAllowed: userResponse.isAdminUserAllowed,
                    }),
                );
            },
        }),
    }),
});

export const { useGetCurrentUserQuery } = userApi;
